var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 10.7339V9.26718C1.66667 8.40052 2.37501 7.68385 3.25001 7.68385C4.75834 7.68385 5.37501 6.61718 4.61667 5.30885C4.18334 4.55885 4.44167 3.58385 5.20001 3.15052L6.64167 2.32552C7.30001 1.93385 8.15001 2.16718 8.54167 2.82552L8.63334 2.98385C9.38334 4.29218 10.6167 4.29218 11.375 2.98385L11.4667 2.82552C11.8583 2.16718 12.7083 1.93385 13.3667 2.32552L14.8083 3.15052C15.5667 3.58385 15.825 4.55885 15.3917 5.30885C14.6333 6.61718 15.25 7.68385 16.7583 7.68385C17.625 7.68385 18.3417 8.39218 18.3417 9.26718V10.7339C18.3417 11.6005 17.6333 12.3172 16.7583 12.3172C15.25 12.3172 14.6333 13.3838 15.3917 14.6922C15.825 15.4505 15.5667 16.4172 14.8083 16.8505L13.3667 17.6755C12.7083 18.0672 11.8583 17.8339 11.4667 17.1755L11.375 17.0172C10.625 15.7089 9.39167 15.7089 8.63334 17.0172L8.54167 17.1755C8.15001 17.8339 7.30001 18.0672 6.64167 17.6755L5.20001 16.8505C4.44167 16.4172 4.18334 15.4422 4.61667 14.6922C5.37501 13.3838 4.75834 12.3172 3.25001 12.3172C2.37501 12.3172 1.66667 11.6005 1.66667 10.7339Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/settingIcon.abc33fd5a0e677e5c368d80e969b4aeb.svg";
export { ForwardRef as ReactComponent };